export const name = 'composePdfDialogController';
export default function composePdfDialogController($scope, templatesService, presetsService, $mdDialog, $state, $interval, $timeout, $window, $translate, errorDialogOpen) {
    //noinspection BadExpressionStatementJS
    'ngInject';
    /* jshint validthis: true */

    let vm = this;

    const splitToolTipVissability = 'splitToolTipVissability';
    vm.initialState = 'initialState';
    vm.inProgressState = 'inProgressState';
    vm.errorState = 'errorState';
    vm.successfulState = 'successfulState';
    vm.selectedSplitType = 'Chunks';
    vm.dialogState = vm.initialState;
    vm.initialized = false;
    vm.splitTooltipVisibility = false;
    vm.numberOfRecordsInRange = vm.totalNumberOfRecords;
    vm.totalNumberOfRowsInRange = vm.totalNumberOfRows;
    vm.errorMessage = null;
    vm.cancel = cancel;
    vm.compose = compose;
    vm.goToPdfListView = goToPdfListView;
    vm.dismissSplitTooltip = dismissSplitTooltip;
    vm.openCustomPresetNameInput = false;
    vm.applyCustomPresetSettings = applyCustomPresetSettings;
    vm.saveCustomPreset = saveCustomPreset;
    vm.splitMessage = "";
    vm.isJobPropertiesArrived = false;
    vm.selectedPresetId = null;
    vm.includeJDF = true;
    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    vm.warningIcon = iconsRequire('./warning.svg');
    vm.infoIcon = iconsRequire('./Info.svg');

    vm.rangeType = {
        ALL: "ALL",
        //SPLIT: "SPLIT",
        RANGE: "RANGE",
        ROWS_RANGE: "ROWS-RANGE"
    };

    vm.splitTypes = {
        //SHEETS: "Sheets",
        CHUNKS: "Chunks",
        RECORDS: "Records"
    };

    vm.outputType = {
        SPLIT: "SPLIT",
        MERGE: "MERGE",
        ZIP: "ZIP"
    };

    vm.userSelection = {
        splitElementsNumber: 3,
        // select which option of records distribution
        _selectedRangeType: vm.rangeType.ALL,
        selectedRangeType: function (newSelectedRangeType) {
            if (angular.isDefined(newSelectedRangeType)) {
                let valueBeforeChange = this._selectedRangeType;
                this._selectedRangeType = newSelectedRangeType;

                if (valueBeforeChange !== this._selectedRangeType) {
                    this._fromRecord = 1;
                    if (this._selectedRangeType === vm.rangeType.ALL) {
                        vm.numberOfRecordsInRange = vm.totalNumberOfRecords;
                    } else if (this._selectedRangeType === 'RANGE') {
                        this.customRange = vm.userSelection._fromRecord + '-' + vm.totalNumberOfRows;

                        /*vm.switchSelectedSplitType(vm.splitTypes.RECORDS);
                        if(vm.userSelection.splitElementsNumber > vm.totalNumberOfRecords) {
                          vm.userSelection.splitElementsNumber = vm.totalNumberOfRecords;
                        }*/
                    }

                    /*if(vm.repetitionColumn){
                      vm.numberOfRecordsInRange = calculateNumOfRecords(this.customRange());
                      vm.numberOfSheetsInRange = gettotalNumberOfRecords();
                    }*/
                    this.toRecord(vm.totalNumberOfRecords);
                    calculateSplitOutcome(vm.userSelection.splitElementsNumber);
                }
            } else {
                return this._selectedRangeType;
            }
        },

        _selectedOutput: vm.outputType.MERGE,
        selectedOutput: function (newSelectedOutputType) {
            if (angular.isDefined(newSelectedOutputType)) {
                this._selectedOutput = newSelectedOutputType;
            } else {
                return this._selectedOutput;
            }
        },

        // whether to apply imposition or not
        _applyImposition: !!vm.isImpositionExist,
        applyImposition: function (applyImpositionNew) {
            if (angular.isDefined(applyImpositionNew)) {
                if (vm.isImpositionExist) {
                    this._applyImposition = applyImpositionNew;
                } else {
                    this._applyImposition = false;
                }
            } else {
                return this._applyImposition;
            }
        },

        _fromRecord: 1,
        fromRecord: function (fromRecordNew) {
            if (angular.isDefined(fromRecordNew)) {
                this._fromRecord = fromRecordNew;
            } else {
                return this._fromRecord;
            }
        },

        _toRecord: vm.totalNumberOfRecords,
        toRecord: function (toRecordNew) {
            if (angular.isDefined(toRecordNew)) {
                this._toRecord = toRecordNew;
            } else {
                return this._toRecord;
            }
        },
        customRange: 1 + '-' + this.totalNumberOfRows,
        customRangeChange: function () {
            if (angular.isDefined(this.customRange)) {
                let isIllegalLocated = isLegalRange(this.customRange);

                if (isIllegalLocated) {
                    $scope.createPdfForm.customRange.$setValidity("badRange", false);
                } else {
                    if ($scope.createPdfForm.customRange) {
                        $scope.createPdfForm.customRange.$setValidity("badRange", true);
                    }
                    vm.numberOfRecordsInRange = calculateNumOfRecords(this.customRange);
                    if(vm.dbList && vm.dbList[0] && vm.dbList[0].parseData){
                        vm.dbList[0].parseData.numberOfRecordsInRange =  vm.numberOfRecordsInRange;
                    }
                    if (vm.numberOfRecordsInRange <= 1) {
                        this.splitElementsNumber = 1;
                        this.split = false;
                    }
                    let isNumberOfRecordsInRangeChange = true;
                    calculateSplitOutcome(this.splitElementsNumber, isNumberOfRecordsInRangeChange);
                }

                if ($scope.createPdfForm.customRange) {
                    $scope.createPdfForm.customRange.$setTouched();
                }
            } else {
                $scope.createPdfForm.customRange.$setValidity("badRange", false);
                if ($scope.createPdfForm.customRange) {
                    $scope.createPdfForm.customRange.$setTouched();
                }
            }
        },
        splitElementsNumberChange: function () {
            if (vm.userSelection.splitElementsNumber) {
                $scope.createPdfForm.splitRecords.$setValidity("splitNumber", true);
                calculateSplitOutcome(vm.userSelection.splitElementsNumber);
            } else {
                $scope.createPdfForm.splitRecords.$setValidity("splitNumber", false);
                calculateSplitOutcome(-1);
            }
            if ($scope.createPdfForm.splitRecords) {
                $scope.createPdfForm.splitRecords.$setTouched();
            }
        }
    };

    vm.switchSelectedSplitType = function (selectedSplitType) {
        if (vm.selectedSplitType !== selectedSplitType) {
            vm.selectedSplitType = selectedSplitType;
            vm.splitTypeChanged = true;

            if (angular.isDefined(vm.userSelection.splitElementsNumber)) {
                vm.userSelection.splitElementsNumber = Math.ceil(vm.numberOfRecordsInRange / vm.userSelection.splitElementsNumber);
            } else if (selectedSplitType === vm.splitTypes.RECORDS) {
                vm.userSelection.splitElementsNumber = vm.numberOfRecordsInRange;
            } else {
                vm.userSelection.splitElementsNumber = 3;
            }
            calculateSplitOutcome(vm.userSelection.splitElementsNumber);
        }
    };

    (function initialize() {
        vm.dialogState = vm.initialState;
        vm.initialized = true;

        if (vm.selectedPreset) {
            vm.selectedPresetId = vm.selectedPreset.id;
            applyCompositionPresetSettings(true);
        }

        if (vm.fixedNumberOfRows > 1) {
            vm.totalNumberOfRecords = vm.numberOfRecordsInRange = Math.ceil(vm.totalNumberOfRecords / vm.fixedNumberOfRows);
        }

        if (vm.totalNumberOfRecords < 1000 || (vm.minNumberOfRecords && vm.minNumberOfRecords < 1000)) {
            vm.userSelection.split = false;
            vm.userSelection.splitElementsNumber = 1;
        } else if (vm.selectedPreset.splitTo > 1) {
            vm.userSelection.split = true;
        }
    })();

    function dismissSplitTooltip(event) {
        event.preventDefault();
        event.stopPropagation();
        vm.splitTooltipVisibility = false;
        sessionStorage.setItem(splitToolTipVissability, 'true');
    }

    function calculateSplitOutcome(splitElementsNumber, isNumberOfRecordsInRangeChange) {
        splitElementsNumber = Number(splitElementsNumber);
        let isNumber = new RegExp('^[0-9]+$').test(splitElementsNumber);
        //
        for (let db of vm.dbList) {
            let numberOfRecordsInRangePerDb = db.parseData.totalNumberOfRecords;
            db.parseData.numberOfRecordsInRange = db.parseData.totalNumberOfRows;
            if(isNumberOfRecordsInRangeChange){
                numberOfRecordsInRangePerDb = vm.numberOfRecordsInRange;
                db.parseData.numberOfRecordsInRange = numberOfRecordsInRangePerDb;
            }

            let minNumberOfRecords = Math.ceil(numberOfRecordsInRangePerDb / 100);
            let maxNumberOfRecords = numberOfRecordsInRangePerDb;
            let numberMustBeBetween = '';
            if (vm.selectedSplitType === vm.splitTypes.CHUNKS) {
                minNumberOfRecords = 1;
                maxNumberOfRecords = numberOfRecordsInRangePerDb > 100 ? 100 : numberOfRecordsInRangePerDb;
                numberMustBeBetween = $translate.instant("imposer.composer-main.Composer_Number_Of_Chunks_Must_be_Betwee");
            } else {
                numberMustBeBetween = $translate.instant("imposer.composer-main.Composer_Number_Of_Records_Must_be_Betwee");
            }
            // first check if input is a number
            if (!isNumber || vm.selectedSplitType === vm.splitTypes.RECORDS && splitElementsNumber < minNumberOfRecords ||
                vm.selectedSplitType === vm.splitTypes.CHUNKS && splitElementsNumber > 100 || splitElementsNumber > numberOfRecordsInRangePerDb) {
                vm.splitMessage = "(" + numberMustBeBetween + " " + minNumberOfRecords + " " + $translate.instant("imposer.composer-main.Composer_And") + " " + maxNumberOfRecords + ")";
                vm.invalidSplit = true;
            } else {
                vm.splitMessage = '';
                vm.totalNumberOfJobs = $window.Math.ceil(numberOfRecordsInRangePerDb / splitElementsNumber);
                vm.invalidSplit = false;
            }

            if ($scope && $scope.createPdfForm && $scope.createPdfForm.splitRecords) {
                if (vm.invalidSplit) {
                    $scope.createPdfForm.splitRecords.$setValidity("splitNumber", false);
                    break;
                } else {
                    $scope.createPdfForm.splitRecords.$setValidity("splitNumber", true);
                }
                $scope.createPdfForm.splitRecords.$setTouched();
            }
        }

        //

    }


    function isLegalRange(customRange) {
        let isIllegalLocated = false;
        let tupleRanges = [];
        let singleValueRanges = [];

        function isRangeIncludeSigleValues(from, to) {
            return singleValueRanges.filter(singleValue => (singleValue >= from && singleValue <= to)).length > 0;
        }

        function isSingleValueInRange(singleValue) {
            for (let iRange = 0; iRange < tupleRanges.length; iRange++) {
                if (singleValue >= tupleRanges[iRange][0] && singleValue <= tupleRanges[iRange][1]) {
                    return true;
                }
            }
        }

        let tokens = customRange.split(',');
        for (let iToken = 0; iToken < tokens.length; iToken++) {

            // check if this is case of range or single value
            if (tokens[iToken].indexOf('-') !== -1) { // range case
                let numbers = tokens[iToken].split('-');

                // check if there are 2 numbers in the range
                if (numbers.length !== 2) {
                    isIllegalLocated = true;
                    break;
                } else { // check if both are indeed numbers
                    numbers[0] = Number(numbers[0]);
                    numbers[1] = Number(numbers[1]);
                    if (Number.isNaN(numbers[0]) || Number.isNaN(numbers[1])) {
                        isIllegalLocated = true;
                        break;
                    } else {
                        // check that the numbers are grater than 0
                        if ((numbers[0] < 1) || (numbers[1] < 1)) {
                            isIllegalLocated = true;
                            break;
                        } else {
                            // check that the numbers are Integers
                            if (($window.Math.ceil(numbers[0]) !== numbers[0]) || ($window.Math.ceil(numbers[1]) !== numbers[1])) {
                                isIllegalLocated = true;
                                break;
                            } else {
                                // check if range is legal - second must be >= first
                                if (numbers[0] > numbers[1]) {
                                    isIllegalLocated = true;
                                    break;
                                } else {
                                    // check that the second in range doesn't exceeds the max value
                                    if (numbers[1] > vm.totalNumberOfRows) {
                                        isIllegalLocated = true;
                                        break;
                                    } else {
                                        // prevent duplicate values
                                        for (let iRange = 0; iRange < tupleRanges.length; iRange++) {
                                            if (numbers[1] >= tupleRanges[iRange][0] && numbers[1] <= tupleRanges[iRange][1] ||
                                                numbers[0] <= tupleRanges[iRange][1] && numbers[0] >= tupleRanges[iRange][0] ||
                                                isRangeIncludeSigleValues(numbers[0], numbers[1])) {
                                                return true;
                                            }
                                        }
                                        tupleRanges.push([numbers[0], numbers[1]]);
                                    }
                                }
                            }
                        }
                    }
                }
            } else { // single value case
                tokens[iToken] = Number(tokens[iToken]);
                // check if both are indeed number
                if (Number.isNaN(tokens[iToken])) {
                    isIllegalLocated = true;
                    break;
                } else {
                    // check that the number are grater than 0
                    if (tokens[iToken] < 1) {
                        isIllegalLocated = true;
                        break;
                    } else {
                        // check that the number is Integer
                        if ($window.Math.ceil(tokens[iToken]) !== tokens[iToken]) {
                            isIllegalLocated = true;
                            break;
                        } else {
                            // check that the number doesn't exceed the max value
                            if (tokens[iToken] > vm.totalNumberOfRows) {
                                isIllegalLocated = true;
                                break;
                            } else {
                                if (singleValueRanges.includes(tokens[iToken]) || isSingleValueInRange(tokens[iToken])) {
                                    return true;
                                }
                                singleValueRanges.push(tokens[iToken]);
                            }
                        }
                    }
                }
            }
        }
        return isIllegalLocated;
    }

    function calculateNumOfRecords(customRange) {
        let tokens = customRange.split(',');
        let numberOfRecords = 0;
        vm.totalNumberOfRowsInRange = 0;
        for (let iToken = 0; iToken < tokens.length; iToken++) {
            // check if this is case of range or single value
            if (tokens[iToken].indexOf('-') !== -1) { // range case
                let numbers = tokens[iToken].split('-');
                if (vm.repetitionColIndex !== null) {
                    for (let iRecord = +numbers[0] - 1; iRecord < +numbers[1]; iRecord++) {
                        if (isNaN(vm.data[iRecord][vm.repetitionColIndex]) === false) {
                            numberOfRecords += +vm.data[iRecord][vm.repetitionColIndex];
                        } else {
                            numberOfRecords++;
                        }
                    }
                    vm.totalNumberOfRowsInRange += numbers[1] - numbers[0] + 1;
                } else {
                    numberOfRecords += numbers[1] - numbers[0] + 1;
                }
            } else {
                if (vm.repetitionColIndex !== null) {
                    if (isNaN(vm.data[tokens[iToken] - 1][vm.repetitionColIndex]) === false) {
                        numberOfRecords += +vm.data[tokens[iToken] - 1][vm.repetitionColIndex];
                    } else {
                        numberOfRecords++;
                    }
                    vm.totalNumberOfRowsInRange++;
                } else {
                    numberOfRecords++;
                }
            }
        }
        if (vm.fixedNumberOfRows) {
            numberOfRecords = Math.ceil(numberOfRecords / vm.fixedNumberOfRows);
        }

        return numberOfRecords === 0 ? 1 : numberOfRecords;
    }

    function applyCompositionPresetSettings(applyNameConvention = false) {

        if (applyNameConvention) {
            // the PDF name
            let placeholders = ['<TEMPLATE_NAME>', '<DATABASE_NAME>', '<RANGE>', '<ASSETS_FOLDER>', '<DATE_TIME>'];

            //if (!vm.dbList || vm.dbList.length < 2) { // not MultiDb
            for (let db of vm.dbList) {
                let pdfName = vm.selectedPreset.outputNameConvention.replace('<TEMPLATE_NAME>', vm.templateName);

                // if (vm.dataFileName !== null) {
                //     pdfName = pdfName.replace('<DATABASE_NAME>', vm.dataFileName);
                // }
                if (vm.dataFileName !== null) {
                    pdfName = pdfName.replace('<DATABASE_NAME>', db.fileName);
                }
                if (vm.userSelection.customRange) {
                    pdfName = pdfName.replace('<RANGE>', vm.userSelection.customRange);
                }
                //}

                pdfName = pdfName.replace('<DATE_TIME>', new Date().toLocaleDateString().replace(/\//g, '-'));

                if (vm.assetsLibraries && vm.assetsLibraries.length > 0) {
                    let librariesNames = vm.assetsLibraries.map(assetFolder => assetFolder.name).join('_');
                    pdfName = pdfName.replace('<ASSETS_FOLDER>', librariesNames);
                }

                if (!pdfName) { //if file name is empty
                    pdfName = vm.templateName;
                }

                placeholders.forEach(placeholder => {
                    let indexOfPlaceHolder = pdfName.indexOf(placeholder);
                    if (indexOfPlaceHolder === 0) {
                        if (pdfName.indexOf(placeholder + '_') === 0) {
                            pdfName = pdfName.replace(placeholder + '_', '');
                        } else {
                            pdfName = pdfName.replace(placeholder, '');
                        }
                    } else if (indexOfPlaceHolder > 0) {
                        if (pdfName.indexOf('_' + placeholder) > 0) {
                            pdfName = pdfName.replace('_' + placeholder, '');
                        } else {
                            pdfName = pdfName.replace(placeholder, '');
                        }
                    }
                });
                db.pdfName = pdfName;
            }
            if(vm.dataFileName && vm.dbList.filter(x => x.fileName === vm.dataFileName)[0]){
                vm.pdfName = vm.dbList.filter(x => x.fileName === vm.dataFileName)[0].pdfName;//vm.dbList[0].pdfName;
            }
            else if(vm.dbList[0]){
                vm.pdfName = vm.dbList[0].pdfName;
            }
        }

        vm.userSelection.applyImposition(vm.selectedPreset.applyImposition);

        if (vm.numberOfRecordsInRange > 1 && (!vm.minNumberOfRecords || (vm.minNumberOfRecords && vm.minNumberOfRecords > 1))) {
            if (vm.selectedPreset.splitTo > -1) {
                vm.userSelection.split = true;
                $scope.$watch('$viewContentLoaded', function () {
                    $timeout(function () {
                        if (vm.isCustomDistributionEnabled) {
                            vm.switchSelectedSplitType(vm.splitTypes.CHUNKS);
                        } else {
                            vm.switchSelectedSplitType(vm.selectedPreset.splitType);
                        }

                        let outputFormat = vm.outputType.MERGE;
                        switch (vm.selectedPreset.outputFormat) {
                            case 'MultiPDF':
                                outputFormat = vm.outputType.SPLIT;
                                break;
                            case 'ZIP':
                                outputFormat = vm.outputType.ZIP;
                                break;
                        }

                        vm.userSelection.selectedOutput(outputFormat);
                        if (vm.numberOfRecordsInRange < vm.selectedPreset.splitTo) {
                            vm.selectedPreset.splitTo = vm.numberOfRecordsInRange;
                        }
                        vm.userSelection.splitElementsNumber = vm.selectedPreset.splitTo;
                        vm.userSelection.splitElementsNumberChange();
                        vm.splitTypeChanged = false;
                    }, 0);
                });
            } else {
                vm.userSelection.split = false;
            }
        }
        vm.customPresetName = vm.selectedPreset.sameNameIndex > 0 ? vm.selectedPreset.name.replace('-' + vm.selectedPreset.sameNameIndex, '') : vm.selectedPreset.name;
        vm.openCustomPresetNameInput = false;
        vm.splitTypeChanged = false;
        if ($scope.createPdfForm) {
            $scope.createPdfForm.$setPristine();
        }
    }

    function applyCustomPresetSettings(applyNameConvention = false) {
        for (let preset of vm.presets) {
            if (vm.selectedPresetId === preset.id) {
                vm.selectedPreset = preset;
                break;
            }
        }

        vm.applyTemplatePresetSettings(vm.selectedPreset, true, true);
        applyCompositionPresetSettings(applyNameConvention);
        $scope.createPdfForm.splitRecords.$setPristine();
    }

    function saveCustomPreset($event) {
        let customPreset = angular.copy(vm.selectedPreset);

        customPreset.id = null;
        customPreset.name = vm.customPresetName;
        customPreset.applyImposition = vm.userSelection.applyImposition();
        customPreset.splitEnabled = vm.userSelection.split;
        customPreset.splitTo = vm.userSelection.splitElementsNumber;
        customPreset.splitType = vm.selectedSplitType;

        switch (vm.userSelection.selectedOutput()) {
            case "MERGE":
                customPreset.outputFormat = "SinglePDF";
                break;
            case "ZIP":
                customPreset.outputFormat = "ZIP";
                break;
            case "SPLIT":
                customPreset.outputFormat = "MultiPDF";
                break;
        }

        presetsService.addPreset(customPreset).then(newPreset => {
            if (newPreset) {
                vm.selectedPreset = newPreset;
                vm.selectedPresetId = newPreset.id;
                applyCustomPresetSettings();
            }
        }, error => {
            errorDialogOpen.openErrorDialog(error);
        });
    }

    function compose() {
        vm.composed = true;
        vm.dialogState = vm.inProgressState;


        let split = null;
        let selectedOutput = this.userSelection.selectedOutput();
        if (vm.userSelection.split === false) {
            selectedOutput = vm.outputType.SPLIT;
        } else if (vm.selectedSplitType === vm.splitTypes.RECORDS && this.userSelection.splitElementsNumber < vm.totalNumberOfRecords) {
            split = vm.userSelection.splitElementsNumber;
        } else if (vm.selectedSplitType === vm.splitTypes.CHUNKS && this.userSelection.splitElementsNumber > 1) {
            split = vm.userSelection.splitElementsNumber;
        } else {
            selectedOutput = vm.outputType.SPLIT;
            vm.selectedSplitType = vm.splitTypes.RECORDS;
        }
        if (selectedOutput !== vm.outputType.ZIP) {
            vm.includeJDF = false;
        }
        /////
        let composePdfRequests = [];

        for (let db of vm.dbList) {
            let filteredData = {
                data: db.parseData.data,
                offsets: null
            };

            if (vm.dataStorageId === null && vm.userSelection.selectedRangeType() !== vm.rangeType.ALL) {
                filteredData = removeRecordsNotInRange(vm.data);
            }
            let dataStorageDetails = vm.dataStorageIds.filter(x => x.fileName === db.fileName);
            let composePdfRequest = {
                dataStorageId: (dataStorageDetails.length > 0)? dataStorageDetails[0].storageId : null,//vm.dataStorageId,//list
                recordRange: null,
                skipRecords: vm.skipFirstRecord ? 1 : 0,
                applyImposition: vm.userSelection.applyImposition(),
                dataFileName: db.fileName,
                pdfName: (vm.dbList.length === 1)? vm.pdfName : db.pdfName,
                rangeType: vm.selectedSplitType,
                split: split,
                selectedOutput: selectedOutput,
                includeJDF: vm.includeJDF,
                assetsLibraries: vm.assetsLibraries,
                numOfRecords: db.parseData.numberOfRecordsInRange,
                delimiter: db.parseData.delimiter,
                offsets: filteredData.offsets,
                vdpData: filteredData.data,
                missingImagesHandling: vm.selectedPreset.missingImagesHandling,
                missingFontsHandling: vm.selectedPreset.missingFontsHandling,
                clientTimestampInMilliseconds: (new Date()).getTime() - (new Date()).getTimezoneOffset() * 60 * 1000,
                outputPdfName: templatesService.producePdfOutputName(vm.templateName, db.fileName)
            };
            composePdfRequests.push(composePdfRequest);
        }


        templatesService.composePdf(vm.templateId, composePdfRequests).then(// filteredData.data, vm.templateName, vm.dataFileName
            function () {
                vm.dialogState = vm.successfulState;
            }, function (error) {
                vm.dialogState = vm.errorState;
            }
        );
    }
    function removeRecordsNotInRange(data) {
        // normalize record types to the same format
        let normalizedRangeString = vm.userSelection.customRange;

        // turn to array with from\to numbers
        let stringRangesArray = normalizedRangeString.split(",");
        let numbersRangeArray = [];
        for (let iStringRange = 0; iStringRange < stringRangesArray.length; iStringRange++) {
            let fromToNumbers = {};
            if (stringRangesArray[iStringRange].indexOf('-') !== -1) {
                let fromToStrings = stringRangesArray[iStringRange].split('-');
                fromToNumbers.from = Number(fromToStrings[0]);
                fromToNumbers.to = Number(fromToStrings[1]);
            } else {
                fromToNumbers.from = Number(stringRangesArray[iStringRange]);
                fromToNumbers.to = Number(stringRangesArray[iStringRange]);
            }
            numbersRangeArray.push(fromToNumbers);
        }

        let newData = [];
        let offsets = [];
        // loop and push data into newData
        for (let iNumbersRange = 0; iNumbersRange < numbersRangeArray.length; iNumbersRange++) {
            let lengthOfRecords = numbersRangeArray[iNumbersRange].to - numbersRangeArray[iNumbersRange].from + 1;
            if (vm.fixedNumberOfRows) {
                lengthOfRecords = Math.ceil(lengthOfRecords / vm.fixedNumberOfRows);
            }
            offsets.push({
                offset: numbersRangeArray[iNumbersRange].from,
                lengthOfRecords: lengthOfRecords
            });
            for (let iRecordNumber = numbersRangeArray[iNumbersRange].from; iRecordNumber <= numbersRangeArray[iNumbersRange].to; iRecordNumber++) {
                newData.push(data[iRecordNumber - 1]);
            }
        }

        return {
            data: newData,
            offsets: {
                offsets: offsets
            }
        };
    }

    function goToPdfListView() {
        $state.go('pdflist');
        $mdDialog.hide();
    }

    function cancel() {
        $mdDialog.cancel();
    }

    vm.toggleSplit = function () {
        if (vm.userSelection.split) {
            if (vm.numberOfRecordsInRange >= 3) {
                if (vm.selectedSplitType === vm.splitTypes.RECORDS && (vm.numberOfRecordsInRange / vm.userSelection.splitElementsNumber) < 100) {
                    vm.userSelection.splitElementsNumber = Math.ceil(vm.numberOfRecordsInRange / 3);
                } else {
                    vm.userSelection.splitElementsNumber = 3;
                }
            } else {
                if (vm.selectedSplitType === vm.splitTypes.RECORDS) {
                    vm.userSelection.splitElementsNumber = vm.numberOfRecordsInRange;
                } else {
                    vm.userSelection.splitElementsNumber = 1;
                }
            }
            $scope.createPdfForm.splitRecords.$setPristine();
        }
    };
}
